import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { disableParkingService } from '../../api/parking-service.ts';

export default function useDisableParkingService(): UseMutationResult<
  Awaited<ReturnType<typeof disableParkingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => disableParkingService(serviceId),
  });
}
